import { FooterConfig } from '@tenants/types/tenant';
import { NEWHOMES_ROUTE } from 'components/dynamic-page/route-matchers';
import { CountryCodeList } from 'types/countries';
import { ZOOCASA_ADDRESS, EXP_CANADA_ADDRESS } from '@tenants/definitions/shared/addresses';

export function createFooterConfig(): FooterConfig {
  return {
    footerColumns: {
      joinUsLink: '/search',
      footerImageData: {
        src: '/next/assets/images/zoocasa-footer-pic.png',
        alt: 'A group of people at an event are laughing and cheering, with one man enthusiastically greeting a seated couple in the front row.',
      },
    },
    organization: {
      phoneNumber(route) {
        return route === NEWHOMES_ROUTE ? '1-647-952-6657' : '1-844-683-4663';
      },
      email(route) {
        return route === NEWHOMES_ROUTE ? 'newhomes@zoocasa.com' : 'INFO@ZOOCASA.COM';
      },
      address(siteLocation) {
        return siteLocation === CountryCodeList.UNITED_STATES ? EXP_CANADA_ADDRESS : ZOOCASA_ADDRESS;
      },
      twitterUrl: 'https://x.com/zoocasa',
      facebookUrl: 'https://www.facebook.com/Zoocasa/',
      instagramUrl: 'https://www.instagram.com/zoocasa/',
      linkedinUrl: 'https://www.linkedin.com/company/zoocasa-com/',
    },
    showAccessibilityLink: true,
  };
}